import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-conditions-of-use',
  templateUrl: './general-conditions-of-use.component.html',
  styleUrls: ['./general-conditions-of-use.component.scss']
})
export class GeneralConditionsOfUseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
